import {useEffect} from 'react';

import * as Sentry from '@sentry/react';
import {useLocation} from 'react-router-dom';

function useEmbedReportLoadingTracking({isLoading, isLoadingHidden, isProjectSlicerLoading, selectedReport, selectedProject, isSlicerLoading}) {
  const location = useLocation();

  useEffect(() => {
    if (isLoadingHidden) return;
    if (!location.pathname.startsWith('/reports')) return;

    const TIME_BEFORE_SENDING_LOGS_TO_SENTRY = 5000;
    const timeoutId = setTimeout(() => {
      console.info({
        isLoading,
        isLoadingHidden,
        isProjectSlicerLoading,
        selectedReport,
        selectedProject,
        isSlicerLoading
      });
      Sentry.captureMessage(`Power BI report loading did not resolved the endLoading event after ${TIME_BEFORE_SENDING_LOGS_TO_SENTRY / 1000} seconds`, {
        level: 'warning',
        extra: {
          isLoading,
          isLoadingHidden,
          isProjectSlicerLoading,
          selectedReport,
          selectedProject,
          isSlicerLoading
        }
      });
    }, TIME_BEFORE_SENDING_LOGS_TO_SENTRY);

    return () => clearTimeout(timeoutId);
  }, [isLoadingHidden, location.pathname]);
}

export default useEmbedReportLoadingTracking;
